import { createContext, useContext, useEffect, useState } from "react";
import { api, API } from "../lib/api";

const FALLBACK = {
  platform_name: "M Speech, Language & Math Helper",
  tagline: "Supporting every child’s speech and language journey.",
  coach_name: "Pip",
  legal_name: "M Speech, Language & Math Helper",
  domain: null,
  support_email: null,
  logo_url: null,
};

// Server-issued uploaded logos are relative "/api/brand/logo?v=…" paths;
// external logo URLs stay absolute.
const resolveLogo = (logoUrl) => {
  if (!logoUrl) return null;
  if (logoUrl.startsWith("/api/")) return `${API}${logoUrl.slice(4)}`;
  return logoUrl;
};

const BrandContext = createContext({ ...FALLBACK, resolveLogo, logoSrc: null });

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(FALLBACK);

  useEffect(() => {
    api
      .get("/brand")
      .then(({ data }) => data && setBrand(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    document.title = brand.platform_name;
  }, [brand.platform_name]);

  return (
    <BrandContext.Provider value={{ ...brand, resolveLogo, logoSrc: resolveLogo(brand.logo_url) }}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBrand = () => useContext(BrandContext);
